<template>
    <section :class="['error-modal', { 'is-static': this.isStatic }]">
        <i class="material-icons text-error">warning</i>
        <span v-html="errorMessage"></span>
    </section>
</template>

<script>
    export default  {
        name: "ErrorPopup",
        props: {
            errorMessage: String,
            isStatic: Boolean
        },
        mounted() {
            if (!this.isStatic) {
                const errModal = $('.error-modal');
                const errModalHeight = errModal.height();

                const cookieHeight = $(".cookie-check").outerHeight(true) || 0;
                const headerHeight = $("#main-ed-header").outerHeight(true) || 0;
                const spaceUnderHeader = 24;
                const topSpacing = cookieHeight + headerHeight + spaceUnderHeader;

                errModal.css({
                    'top': topSpacing + 'px'
                });

                const loginPositionSpacing = cookieHeight + errModalHeight + spaceUnderHeader;
                $("#students-view-page").addClass("error-alert-open").css({
                    "margin-top": `${loginPositionSpacing}px`
                })
            }
        }
    }
</script>

<style lang="scss">
    .error-modal {
        position: absolute;
        top: -100px;
        left: 50%;
        transform: translateX(-50%);
        animation: showMessage 1s;
        opacity: 1;

        width: 440px;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 17px;
        border-radius: 6px;
        background: $light-orange;
        border: 1px rgba($light-orange, 0.75) solid;

        @media screen and (max-width: 441px) {
            width: calc(100vw - 48px);
        }

        &.is-static {
            position: relative;
            top: 0;
            left: 0;
            transform: none;

            width: 100%;
            padding: 8px 12px;
            max-width: unset;
            border-radius: 4px 4px 0 0;
            font-size: 15px;
        }

        i {
            padding: 12px 0 12px 12px;
            font-size: 24px;
        }

        span {
            padding: 12px 16px 12px 8px;
            line-height: 16px;

            p {
                margin: 0;
            }
        }

        a {
            color: rgba($error, 0.75);
        }
    }

    @keyframes showMessage {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
</style>